import { Route, Routes } from "react-router-dom";
import Login from "../pages/auth/Login";
import ProtectedRoute from "./ProtectedRoute";
import Dashboard from "../pages/dashboard/Dashboard";
import AuthLayout from "../layouts/AuthLayout";
import MainLayout from "../layouts/MainLayout";
import Register from "../pages/auth/Rgister";
import IdCards from "../pages/idCards/IdCards";
import EquipmentCertificates from "../pages/equipmentCertificates/EquipmentCertificates";

const AppRoutes = () => {
  return (
    <Routes>
      {/* AUTH ROUTES */}

      <Route element={<AuthLayout/>}>
        <Route path="/" element={<Login />} />
         <Route path="/register" element={<Register />} />
      </Route>

      {/* PROTECTED ROUTES */}

      <Route
        element={
          <ProtectedRoute>
            <MainLayout />
          </ProtectedRoute>
        }
      >
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/id-cards" element={<IdCards />} />
        <Route path="/equipment-certificates" element={<EquipmentCertificates />} />
      </Route>
    </Routes>
  );
};

export default AppRoutes;